import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';
import { useUser } from '@/store/user';

/**
 * Whether the brand has more than one colour type. With one, every colour has it, so the Colors page
 * leaves out the type column and filter until a second type is added.
 */
export const hasSeveralColorTypes = () => useColorTypes().loaded.length > 1;

export const useColorTypes = defineStore('color-types', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.colorType_GetList,
    dto: 'ColorTypeDto',
    create: api.colorType_Create,
    update: api.colorType_Update,
    delete: api.colorType_Delete,
    usage: api.colorType_GetUsage,
    signalR: 'ColorTypeUpdate',
  });

  async function replace(id: number, replacementId: number) {
    await api.colorType_Replace(useUser().brandId, id, { replacementId });
    await globalStoreBase.loadAll();
  }

  async function reorder(typeIds: number[]) {
    await api.colorType_UpdateOrder(useUser().brandId, typeIds);
    await globalStoreBase.loadAll();
  }

  return {
    ...globalStoreBase,
    replace,
    reorder,
  };
});
